import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CommunicationService {
  private reloadSource = new Subject<void>();
  reload$ = this.reloadSource.asObservable();

  triggerReload() {
    //console.log('CommunicationService: Trigger reload');
    this.reloadSource.next(); // Dispara o evento
  }
}
